const PaginatedListStyle = {
  width: "100%",
};

export { PaginatedListStyle };
